import React from 'react';
import PropTypes from 'prop-types';
import styled from "@emotion/styled";

const DeviceColor = styled.div`
     height: 1rem;
     width: 1rem;
     border: 1px solid var(--line-secondary);
     border-radius: 1rem;
     margin-right: var(--space-l);
`;

function ColorTableCellComponent({color}) {
    return <DeviceColor style={{backgroundColor: color}}/>
};

ColorTableCellComponent.propTypes = {};
ColorTableCellComponent.defaultProps = {};

export default ColorTableCellComponent;